module.exports = __webpack_public_path__ + "img/globeicon.a85292d5.svg";